module.exports = ".text-indicator{cursor:w-resize;pointer-events:auto}";